const udhrPreamble = `
Kontuan izanik munduko askatasuna, justizia eta bakea giza familiako kide
guztien berezko duintasunean eta eskubide berdin eta ukaezinetan oinarritzen
direla;
Kontuan izanik giza eskubideak ez ezagutzearen eta gutxiestearen ondorioz,
giza kontzientziari irain egiten dioten basakeriak gertatu izan direla; eta gizon-
emakumeek, beldur eta gabezia orotik aske, hitz egiteko askatasuna eta
sinesmen-askatasuna izango dituzten munduaren etorrera aldarrikatu dela
gizakiaren helburu nagusi;
Kontuan izanik ezinbestekoa dela giza eskubideak zuzenbidezko erregimen
batek babestea, gizakia-tirania eta zapalkuntzaren aurkako azken irtenbidea den
matxinadara jo beharrean aurkitu ez dadin;
Kontuan izanik ezinbestekoa dela, baita ere, herrialdeen artean harreman
lagunkoiak bultzatzea;
Kontuan izanik Nazio Batuetako kide diren herriek gizakiaren oinarrizko
eskubideetan, gizakiaren duintasun eta balioan eta gizonen eta emakumeen
eskubideen arteko berdintasunean duten fedea tinko azaldu dutela Agirian; eta,
askatasunaren ikuspegi zabalago baten barruan, gizarte aurrerakuntza
sustatzeko eta bizitza-maila jasotzeko erabakita daudela adierazi dutela;
Kontuan izanik Estatu Kideek, Nazio Batuen Erakundearekin elkarlanean,
gizakiaren oinarrizko eskubide eta askatasunen begirune orokorra eta
eraginkorra ziurtatzeko hitza eman dutela;
Kontuan izanik emandako hitz hori osotasunean betetzeko garrantzi handikoa
dela eskubide eta askatasun horiek berdin ulertzea;
`;

const udhr1 = `
Gizon-emakume guztiak aske jaiotzen dira, duintasun eta eskubide berberak dituztela; eta ezaguera eta kontzientzia dutenez gero, elkarren artean senide legez jokatu beharra dute.	
`;

module.exports = {
    name: "Basque",
    udhrPreamble,
    udhr1,
    lang: 'eu',
}